import { ServiceToken } from './api';

// Filter service tokens by a free-text query and a status filter.
export const filterServiceTokens = (
  tokens: ServiceToken[],
  query: string,
  statusFilter: string
): ServiceToken[] => {
  return tokens.filter((token) => {
    // Search filter
    const matchesSearch =
      query === "" ||
      token.service_name.toLowerCase().includes(query.toLowerCase()) ||
      (token.description && token.description.toLowerCase().includes(query.toLowerCase()));

    // Status filter
    const matchesStatus =
      statusFilter === "all" ||
      (statusFilter === "active" && token.is_active) ||
      (statusFilter === "inactive" && !token.is_active);

    return matchesSearch && matchesStatus;
  });
};
